<template>
    <div>
        <button @click="$router.go(-1)" type="button" class="btn btn-lg btn-link">
            <i class="fa fa-arrow-left" aria-hidden="true"></i>
            <span>Back</span>
        </button>

        <div style="min-width: 400px; width: 40vw; margin: auto; margin-top: 100px;" class="border-box">
            <div>
                <h3 class="fg-color-blue">Change your password</h3>
                <br />

                <div class="form-group">
                    <label for="Password">New password:</label>
                    <input v-model="password" type="password" class="form-control">
                    <ValidationError context="Password" :errors="validationErrors"></ValidationError>
                </div>

                <div class="form-group" v-show="password">
                    <label for="PasswordConfirmation">New password confirmation:</label>
                    <input v-model="passwordConfirmation" type="password" class="form-control">
                </div>
                <br />

                <button @click="handleChangePasswordCommandV1" type="button" class="btn btn-primary btn-lg btn-block" :disabled="!isValid">Change password</button>
            </div>

            <div v-if="passwordPolicy" style="margin-top: 25px; font-size: 16px;">
                <strong>Password validation requirements:</strong>
                <ul style="margin-top: 8px;">
                    <li v-for="rule in passwordPolicy.Rules">{{rule}}</li>
                </ul>
            </div>
        </div>
    </div>
</template>

<script lang="ts">
    import Component, { mixins } from 'vue-class-component';
    import PageBase from "@common/PageBase";
    import VuePageQueries from "@Organizations/Users/Domain/queries-vue-component";
    import VuePageCommands from "@Organizations/Users/Domain/commands-vue-component";
    import "@common/Components/ValidationError.vue";

    enum Status {
        NotReset,
        Reseting,
        Reset
    }

    @Component
    export default class ChangePasswordPage extends mixins(PageBase, VuePageQueries, VuePageCommands) {
        password = '';
        passwordConfirmation = '';
        status: Status = Status.NotReset;

        get userSessionDetails() { return this?.model?.UserSessionDetails; }
        get userId() { return this.userSessionDetails?.UserId; }

        get passwordPolicy() { return this?.model?.PasswordPolicy; }

        get isStatusNotReset() { return this.status == Status.NotReset }
        get isStatusReseting() { return this.status == Status.Reseting }
        get isStatusReset() { return this.status == Status.Reset }

        get passwordConfirmed() { return this.password == this.passwordConfirmation }
        get isValid() { return this.password && this.passwordConfirmed }

        mounted() {
            this.setTitle("Change password");
            this.runCurrentUserQueryV1();
            this.runPasswordPolicyQueryV1();
        }

        handleChangePasswordCommandV1() {
            if (this.password == this.passwordConfirmation) {
                this.invokeChangePasswordCommandV1(this.userId, this.password);
            }
        }

        succeedChangePasswordCommandV1() {
            this.navigateTo('/');
        }

        invalidChangePasswordCommandV1(status) {
            this.$pushValidationErrors(status.ValidationErrors);
        }

        failedChangePasswordCommandV1() {
            alert("Unknown error occured when changing password")
        }
    }
</script>

<style scoped>
</style>